import { CreatePartnerContactRequestSchema, CreatePartnerContactResponseSchema } from './create-partner-contact.schema';
export const createPartnerContactContract = {
    method: 'POST',
    path: '/api/v2/partner/contacts',
    description: "Add a contact to the caller's partner call list",
    requestSchema: CreatePartnerContactRequestSchema,
    responseSchema: CreatePartnerContactResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member'
        }
    }
};

//# sourceMappingURL=create-partner-contact.contract.js.map